import { MetaTags } from '@devd-client/devd/components';
import GoalsPage from './devd-goals';

export function WorkflowAutomation() {
  return (
    <>
      <MetaTags title="Automation | Devdynamics" />
      <GoalsPage />
    </>
  );
}

export default WorkflowAutomation;
